import React, { useState, useCallback, useEffect, useRef } from "react";
import classNames from "classnames";
import { fetchStops } from "../../api";
import MultiSelect from "./MultiSelect";
import Button from "../button/Button";
import Dropdown from "../dropdown/Dropdown";
import { useTranslate } from "../../translate";

const distances = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 1000];
const distancesSchema = distances.map(distance => ({
    id: distance,
    label: `${distance}km`,
}));

function HeaderSearchByNearStop(props) {
    const translate = useTranslate();
    const multiSelectRef = useRef();
    const { selectedStop, onSubmit, closeModal, tags } = props;
    const stopTags = selectedStop?.tags?.tags ?? [];
    const [distance, setDistance] = useState(distancesSchema[0]);
    const [tagIds, setTagIds] = useState(stopTags.map(item => item.id));
    const [totalResults, setTotalResults] = useState(null);
    const disabled = [...tagIds].length === 0 && distance === null;

    const handleTagsChange = useCallback(items => {
        setTagIds(items.map(item => item.id));
    }, []);
    const handleDropdownChange = useCallback(item => {
        setDistance(item);
    }, []);
    const handleSubmit = event => {
        const formData = {
            tagIds,
            distance: distance.id,
            coords: selectedStop.coords,
            //Used in FiltersHeader
            _stop: { ...selectedStop },
        };
        event.preventDefault();
        onSubmit(formData);
        closeModal();
    };
    const clearFilters = () => {
        multiSelectRef.current.resetSelectedValues();
        setTagIds([]);
        setTotalResults(null);
    };

    //Fetch results
    useEffect(() => {
        const callback = async () => {
            const data = await fetchStops({
                start: 0,
                limit: 1,
                tagIds,
                distance: distance.id,
                coords: selectedStop?.coords,
            });
            setTotalResults(data?.totalResults ?? 0);
        };
        callback();
    }, [tagIds, distance, selectedStop]);

    return (
        <div className="trpr-sf-header-search-by-near-stop">
            <div className="trpr-sf-header-search-by-near-stop__top">
                <span>Search within</span>
                {/* TODO: add option to create distances */}
                <Dropdown
                    value={distance}
                    onChange={handleDropdownChange}
                    items={distancesSchema}
                    renderItem={item => item.label}
                />
                <span>of {translate(selectedStop, "name")}</span>
            </div>
            <fieldset className="trpr-fs-region-search__multiselect-field">
                <span className="trpr-fs-region-search__multiselect-label">Select Tags</span>
                <MultiSelect
                    ref={multiSelectRef}
                    selectedValues={stopTags}
                    onChange={handleTagsChange}
                    placeholder="Search"
                    options={tags}
                />
            </fieldset>
            <div className="trpr-fs-region-search__footer">
                <p className={classNames("trpr-fs-region-search__footer-copy", { "no-results": totalResults === 0 })}>
                    {totalResults > 0 && `${totalResults} results found.`}
                    {totalResults === 0 && (
                        <>
                            No results found.
                            <br />
                            Try increasing your search radius or selecting different tags.
                        </>
                    )}
                </p>
                <div className="trpr-atlas-menu-filter__footer-btns">
                    <Button
                        class="trpr-fs-region-search__clear-btn"
                        type="secondary-b"
                        size="48"
                        disabled={disabled}
                        onClick={clearFilters}
                    >
                        Clear all tags
                    </Button>
                    <Button htmlType="button" type="primary-b" size="48" disabled={disabled} onClick={handleSubmit}>
                        Show stops
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default HeaderSearchByNearStop;
